module.exports = __webpack_public_path__ + "static/media/warning_message.df77ae78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AlertForm/assets/warning_message.svg
// module id = 2015
// module chunks = 0